// @flow

import * as React from 'react';
import {useState} from 'react';

const DEFAULT_DURATION_MS = 1500;

export type ShowToastFunction = (toast: React.Node, duration?: number) => void;

/**
 * Holds state temporarily, for a specified duration, before clearing it.
 * Useful for showing "toast" popups and similar elements.
 */
export const useToast = (): [?React.Node, ShowToastFunction] => {
  const [toast, setToast] = useState(null);

  const showToast = (
    toastNode: React.Node,
    duration: number = DEFAULT_DURATION_MS,
  ) => {
    setToast(toastNode);
    setTimeout(() => setToast(null), duration);
  };

  return [toast, showToast];
};
